import React, { useRef } from 'react';
import { useFrame, useThree } from '@react-three/fiber';
import { Sparkles } from '@react-three/drei';

export default function Gateway({ position = [0, 0, -170] }) {
  const groupRef = useRef();
  const meshRef1 = useRef();
  const meshRef2 = useRef();
  const { camera } = useThree();

  useFrame((_, delta) => {
    if (groupRef.current) {
      groupRef.current.rotation.z += delta * 0.08;
      groupRef.current.rotation.x += delta * 0.04;
    }

    // Distance-based visibility: only show when camera reaches z <= -135
    const camZ = camera.position.z;
    let opacity = 0;
    if (camZ <= -130) {
      opacity = Math.min(1, (-130 - camZ) / 20);
    }

    if (meshRef1.current && meshRef1.current.material) {
      meshRef1.current.material.opacity = opacity;
      meshRef1.current.material.transparent = true;
    }
    if (meshRef2.current && meshRef2.current.material) {
      meshRef2.current.material.opacity = opacity * 0.85;
      meshRef2.current.material.transparent = true;
    }
  });

  return (
    <group position={position}>
      <group ref={groupRef}>
        <mesh ref={meshRef1}>
          <torusGeometry args={[8, 0.35, 64, 100]} />
          <meshStandardMaterial
            emissive="#43DDD0"
            emissiveIntensity={3.2}
            color="#ffffff"
            transparent
            opacity={0}
          />
        </mesh>

        <mesh ref={meshRef2} rotation={[Math.PI / 2, 0, 0]}>
          <torusGeometry args={[6.2, 0.18, 32, 100]} />
          <meshStandardMaterial
            emissive="#43DDD0"
            emissiveIntensity={1.8}
            color="#ffffff"
            transparent
            opacity={0}
          />
        </mesh>
      </group>

      <pointLight intensity={2.5} color="#43DDD0" distance={35} />
      <Sparkles count={150} scale={20} size={3} speed={0.5} color="#43DDD0" opacity={0.8} />
    </group>
  );
}
